// https://www.w3schools.com/js/js_cookies.asp

export default class CookieHelper {
    static setCookie(cookieName, cookieValue, expirationDays) {
        const date = new Date()
        date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000)
        let expires = 'expires=' + date.toUTCString()
        document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/'
    }

    static getCookie(cookieName) {
        let name = cookieName + '='
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }

    static isCookieSet(cookieName) {
        return this.getCookie(cookieName) !== ''
    }
}
